export const badgeTypes = {
  success: "success",
  error: "error",
  warn:"warn",
  info: "info",
  default: "default"
}
export const Badge = ({
  type = badgeTypes.success,
  text
}) => {

  const colorClasses = () => {
    switch (type) {
      case badgeTypes.success:
        return "bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100";
      case badgeTypes.error:
        return 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100';
      case badgeTypes.warn:
        return "bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100";
      case badgeTypes.info:
        return "bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100";
      case "default":  
      default:
        return "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200";
    }
  }


  return (
    <span className={`inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium ${colorClasses()}`}>
      {text}
    </span>
  );
}